import React from 'react';
import { cn } from '../../lib/utils';

interface UnassignedCountBadgeProps {
  count: number;
  className?: string;
  'data-testid'?: string;
}

export const UnassignedCountBadge: React.FC<UnassignedCountBadgeProps> = ({
  count,
  className,
  'data-testid': testId = 'gusto-unassigned-badge',
}) => {
  if (count <= 0) {
    return null;
  }

  return (
    <span
      data-testid={testId}
      className={cn(
        'inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-destructive px-1.5 text-xs font-semibold text-destructive-foreground',
        className,
      )}
    >
      {count}
    </span>
  );
};
